import Iterator from "./Iterator";
import IteratorNull from "./IteratorNull";

export default class ComposedIterator {
    //Public:
    constructor(order, array) {
        this._order = order;
        this._array = array;
        this.initIterators();
        if (this.isNotNull()) this.createIterators();
        else this.createNullIterator();
        if (this.isNotSimple()) this.setHierarchy();
        this.saveLowestIterator();
        this.saveHighestIterator();
    }

    next() {
        this._lowestIterator.next();
    }

    hasFinished() {
        return this._highestIterator.hasFinished();
    }

    getValues() {
        let values = [];
        const iterators = this._iterators;
        iterators.forEach(iterator => {
            const value = iterator.getValue();
            values.unshift(value);
        });
        return values;
    }

    getIndices() {
        let indices = [];
        const iterators = this._iterators;
        iterators.forEach(iterator => {
            const index = iterator.getIndex();
            indices.unshift(index);
        });
        return indices;
    }

    setIndexToAll(index) {
        let iterators = this._iterators;
        iterators.forEach(iterator => {
            iterator.setIndex(index);
        });
    }

    setInitialIndexToAll(index) {
        let iterators = this._iterators;
        iterators.forEach(iterator => {
            iterator.setInitialIndex(index);
        });
    }

    setAsDiagonal() {
        let iterators = this._iterators;
        iterators.forEach(iterator => {
            iterator.setAsDiagonal();
        });
    }

    //Private:
    initIterators() {
        this._iterators = [];
    }

    createIterators() {
        let N = this._order;
        for (let i = 0; i < N; i++) {
            let iterator = this.createIterator();
            this.addIterator(iterator);
        }
    }

    setHierarchy() {
        let iterators = this._iterators;
        for (let i = 0; i < iterators.length - 1; i++) {
            const iterator = iterators[i];
            const parentIterator = iterators[i + 1];
            iterator.setParent(parentIterator);
            parentIterator.setChild(iterator);
        }
    }

    saveLowestIterator() {
        const iterators = this._iterators;
        this._lowestIterator = iterators[0];
    }

    saveHighestIterator() {
        const N = this._iterators.length - 1;
        const iterators = this._iterators;
        this._highestIterator = iterators[N];
    }

    createIterator() {
        const array = this._array;
        let iterator = new Iterator(array);
        return iterator;
    }

    createNullIterator() {
        let iterator = new IteratorNull();
        this.addIterator(iterator);
    }

    addIterator(iterator) {
        this._iterators.push(iterator);
    }

    isNotSimple() {
        if (this._order > 1) return true;
        else return false;
    }

    isNotNull() {
        if (this._order > 0) return true;
        else return false;
    }
}
